/* eslint-disable no-useless-return */
/* eslint-disable default-case */
import { LogLevel } from '@azure/msal-browser';

let redirectUri = process.env.REACT_APP_PRODUCTION_HOST;
if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
  redirectUri = process.env.REACT_APP_DEVELOPMENT_HOST;
}

export const msalConfig = {
  auth: {
   clientId: '5e325634-2efe-4ec3-b559-bb2b5f703d8b',
  //  clientId: '1965f3e5-e267-4bf0-b229-0b207ebbf264',
   authority: `https://login.microsoftonline.com/9b766c30-8450-431e-9433-d98a8546c8eb`,
  //  authority: `https://login.microsoftonline.com/52772cbc-68be-4ee3-ad12-99bcb4c46561`,
// This is a URL (e.g.https://login.microsoftonline.com/{yourtenant ID})
    redirectUri : process.env.REACT_APP_PRODUCTION_HOST ,
  },
  cache: {
    cacheLocation: 'localStorage', // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
        }
      },
    },
  },
};
// Can be found in the API Permissions of the ASP.NET Web API
export const loginApiRequest = {
 scopes: ['api://bb8ba8eb-4bc8-427f-adb0-f91d86dc3a8f/api.scope'],
//  scopes: ['api://8800e65b-ee96-4828-bdc7-53b43f37790b/api.scope'],

};